import React, { Component } from 'react';
import { Link } from 'react-router-dom';
import { Helmet } from 'react-helmet';
import Testimonials from '../home/testimonials.js';
import { ReactComponent as IconDropdown } from '../../media/icons/dropdown.svg';

export default class BenefitsHosts extends Component {
    constructor(props) {
        super(props);
        this.state = {
            // Default states
            background_url: "https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/hero/hero.webp",
            question_expanded: false,
            questions_content: [
                {
                    question: 'Why should my property offer curated itineraries?',
                    answer:
                        'Great itineraries elevate guest satisfaction, generate glowing reviews, and help you stand out from competitors who only provide a bed for the night.'
                },
                {
                    question: 'Does Guidr charge hosts to publish itineraries?',
                    answer:
                        'No. Creating and sharing itineraries on Guidr is completely free - your investment is a bit of time, and the payoff is happier guests and extra revenue.'
                },
                {
                    question: 'How do I create an itinerary on Guidr?',
                    answer:
                        'Our drag-and-drop builder lets you add activities, dining, maps, and tips in minutes. Save drafts, manage settings, and update anytime.'
                },
                {
                    question: 'How can guests access my itineraries?',
                    answer:
                        'Embed links or QR codes in booking confirmations, lobby signage, smart-room tablets, or welcome emails. Travelers can also search for and find your itineraries on the Guidr platform if you choose to make your itineraries findable. Guests don’t need to download any app.'
                },
                {
                    question: 'How much effort should I plan with to get started?',
                    answer:
                        'You can create your account and first itineraries with a 30-minute time-invest. Depending ont he number and level of detail for each itinerary, you can easily spend more time but that is not needed.'
                },
                {
                    question: 'Can I edit an itinerary after sharing it?',
                    answer:
                        'Yes - updates go live instantly, so guests always see the latest version without you sending a new link.'
                },
                {
                    question: 'How do itineraries drive revenue?',
                    answer:
                        'Highlight on-site amenities, partner tours, or affiliate experiences. Guidr tracks clicks and gives you insights into how your itineraries are performing.'
                },
                {
                    question: 'Is branding customizable?',
                    answer:
                        'Upload your logo or images that match your brand and add a short welcome note so every itinerary feels like an extension of your brand.'
                },
                {
                    question: 'Can I manage multiple properties?',
                    answer:
                        'Absolutely - create a host profile for each location or manage them all under one account.'
                },
                {
                    question: 'Do I need technical skills?',
                    answer:
                        'Not at all. If you can upload images and type text, you can build itineraries. The only thing you will need is insights into your region and hidden gems that you guests will love. Our team is on standby if you need guidance.'
                }
            ]
        };

        this.toggleQuestion = this.toggleQuestion.bind(this);
    }

    toggleQuestion(question) {
        this.setState({
            question_expanded:
                question === this.state.question_expanded ? false : question
        });
    }

    render() {
        return (
            <div className="content-container">

                <Helmet>
                    {/* Add the breadcrumb schema as JSON-LD */}
                    <script type="application/ld+json">
                        {`
                            {
                                "@context": "https://schema.org",
                                "@type": "BreadcrumbList",
                                "itemListElement": [
                                {
                                    "@type": "ListItem",
                                    "position": 1,
                                    "name": "Guidr Home",
                                    "item": "https://guidr.net/"
                                },
                                {
                                    "@type": "ListItem",
                                    "position": 2,
                                    "name": "Guidr for hotels & hosts",
                                    "item": "https://guidr.net/hosts"
                                }
                                ]
                            }
                        `}
                    </script>
                    <title>{"Improve your guest experience with tailored itineraries | Guidr"}</title>
                </Helmet>

                {/* HERO */}
                <div className="content-container hero-container">
                    <div className="hero__background">
                        <img
                            src={this.state.background_url}
                            alt=""
                            className="hero__background-inner"
                        />
                    </div>
                    <div className="hero__background hero__background--overlay"></div>

                    <div className="content-wrapper--wide persona__hero-wrapper">
                        <div></div>
                        <div className="persona__hero__title-container">
                            <div className="persona__hero__title__element">
                                <h1 className="hero__title__static-content text-herotitle text-color-light">
                                    Wow your guests with ready-made local itineraries
                                </h1>
                            </div>

                            <div className="persona__hero__title__element">
                                <h2 className="hero__title__static-content text-subtitle text-color-light">
                                    Increase satisfaction, boost reviews, and unlock new revenue - all at zero cost
                                </h2>
                            </div>

                            <Link
                                to={'/signup'}
                                className="persona__hero__title__button button button-primary-light"
                            >
                                Start building itineraries
                            </Link>
                        </div>
                    </div>

                </div>

                {/* 3-STEP EXPLAINER */}
                <div className="content-wrapper">
                    <div className="persona__explainer-container">
                        {/* STEP 1 */}
                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">
                                1
                            </div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Curate local itineraries
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_1.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🏨 Highlight nearby gems</span>{' '}
                                    from must-see sights to secret cafés only locals know.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">✍️ Tailor experiences</span>{' '}
                                    for families, couples, adventure seekers, or culture
                                    lovers.
                                </p>
                            </div>
                        </div>

                        {/* STEP 2 */}
                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">
                                2
                            </div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Share with guests
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_2.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🔗 One-click sharing</span>{' '}
                                    via QR codes, confirmation emails, or lobby screens.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">📧 Impress pre-arrival</span>{' '}
                                    by emailing personalized plans before check-in.
                                </p>
                            </div>
                        </div>

                        {/* STEP 3 */}
                        <div className="persona__explainer__element__circle">
                            <div className="persona__explainer__element__circle-inner">
                                3
                            </div>
                        </div>
                        <div className="persona__explainer__element__content">
                            <div className="persona__explainer__element__content__summary">
                                <div className="persona__explainer__element__content__summary_title text-subtitle text-bold">
                                    Delight & upsell
                                </div>
                                <div className="persona__explainer__element__content__summary__video">
                                    <img src={"https://guidr-media.s3.us-east-1.amazonaws.com/static-files/home/personas/creators_3.webp"} className="persona__explainer__element__content__summary__video-inner" />
                                </div>
                            </div>
                            <div className="persona__explainer__element__content__details">
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">🤩 Earn rave reviews</span>{' '}
                                    by turning good stays into unforgettable ones.
                                </p>
                                <p className="persona__explainer__element__content__details__bullet">
                                    <span className="text-bold">💰 Upsell tours &
                                        experiences</span>{' '}
                                    while Guidr tracks incremental revenue.
                                </p>
                            </div>
                        </div>
                    </div>
                </div>

                <div className="content-wrapper">
                    <Testimonials
                        data={this.props.testimonials}
                    />
                </div>

                {/* FAQ */}
                <div className="content-wrapper">
                    <div className="persona__faq-container">
                        <h2 className="persona__faq__title text-title">
                            Frequently asked questions (FAQ)
                        </h2>

                        <div className="persona__faq-wrapper">
                            {this.state.questions_content.map((element, i) => (
                                <div
                                    key={i}
                                    className={
                                        'persona__faq__element' +
                                        (this.state.question_expanded === i
                                            ? ' persona__faq__element--expanded'
                                            : '')
                                    }
                                >
                                    <div
                                        onClick={() => this.toggleQuestion(i)}
                                        className="persona__faq__element__question-wrapper"
                                    >
                                        <div className="persona__faq__element__question__question">
                                            {element.question}
                                        </div>
                                        <div className="persona__faq__element__question__icon">
                                            <IconDropdown className="persona__faq__element__question__icon-inner" />
                                        </div>
                                    </div>
                                    <div className="persona__faq__element__answer">
                                        {element.answer}
                                    </div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}
